import {
  companyIndustriesViewColumns,
  industriesSearchSchema,
  mapCompanyIndustriesViewQuery,
} from "./IndustriesView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyIndustries } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface IndustriesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function IndustriesView(props: IndustriesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={companyIndustriesViewColumns}
      schema={industriesSearchSchema}
      mapQuery={mapCompanyIndustriesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCompanyIndustries, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyDomains", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyDomains", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default IndustriesView;
